import { CService } from "./class.base.service";

class FundService extends CService{
  getValuesByProduct<T = any>(period_id:number, product_id:number) {
    return this.api.get<any, T>(`funds/get-values-by-product/${period_id}/${product_id}`)
  }
  getValuesByCategory<T = any>(period_id:number, category_id:number) {
    return this.api.get<any, T>(`funds/get-values-by-category/${period_id}/${category_id}`)
  }
  getValuesByCompany<T = any>(period_id:number) {
    return this.api.get<any, T>(`funds/get-values-by-company/${period_id}`)
  }
  getExtract<T = any>(params?:any) {
    return this.api.get<any, T>(`funds/extract`,{params})
  }
}

const fundService = new FundService("funds");
export default fundService